// Chrome fires `beforeinstallprompt` very early in the page lifecycle, well
// before KeycloakProvider finishes the SSO roundtrip and renders <App/>. If no
// listener is attached at that moment, the event is gone forever. Importing
// this module from index.jsx (before KeycloakProvider) ensures the listener is
// registered immediately so PwaInstallBanner can pick the event up on mount.

interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{outcome: 'accepted' | 'dismissed'}>;
}

let captured: BeforeInstallPromptEvent | null = null;
const listeners = new Set<(e: BeforeInstallPromptEvent) => void>();

if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        captured = e as BeforeInstallPromptEvent;
        listeners.forEach((fn) => fn(captured!));
    });
    window.addEventListener('appinstalled', () => {
        captured = null;
    });
}

export const getCapturedInstallPrompt = (): BeforeInstallPromptEvent | null => captured;

export const subscribeInstallPrompt = (
    fn: (e: BeforeInstallPromptEvent) => void
): (() => void) => {
    listeners.add(fn);
    return () => {
        listeners.delete(fn);
    };
};

export const clearCapturedInstallPrompt = (): void => {
    captured = null;
};

export type {BeforeInstallPromptEvent};
